/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Blockednolimit2Inputs */

const en__field_blockednolimit2 = /** @type {(inputs: _Field_Blockednolimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked with no automatic cancelation`)
};

const de__field_blockednolimit2 = /** @type {(inputs: _Field_Blockednolimit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blockiert ohne automatische Aufhebung`)
};

/**
* | output |
* | --- |
* | "Blocked with no automatic cancelation" |
*
* @param {_Field_Blockednolimit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_blockednolimit2 = /** @type {((inputs?: _Field_Blockednolimit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Blockednolimit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_blockednolimit2(inputs)
	return de__field_blockednolimit2(inputs)
});
export { _field_blockednolimit2 as "_field_blockedNoLimit" }